module.exports = __webpack_public_path__ + "img/snail-cabbage.199af408.gif";